import { useState } from 'react';
import { testimonials } from '@/mocks/categories';

export default function TestimonialSection() {
  const [active, setActive] = useState(0);

  const current = testimonials[active];

  return (
    <section className="py-16 md:py-20 bg-foreground-950">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl bg-foreground-900/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative overflow-hidden min-h-[350px] lg:min-h-[500px] -mb-8 lg:-mb-0 lg:-ml-8">
              <img
                src={current.image}
                alt={`${current.name} testimonial`}
                title={`${current.name} — ACBuySpreadsheet review`}
                className="w-full h-full object-cover rounded-2xl lg:rounded-r-none"
                loading="lazy"
              />
            </div>

            <div className="lg:w-3/5 flex flex-col justify-center px-6 md:px-12 py-10 lg:py-16">
              <div className="text-accent-500/60 font-heading text-7xl md:text-8xl leading-none mb-4 select-none">
                &ldquo;
              </div>
              <p className="text-background-50 text-lg md:text-xl lg:text-2xl leading-relaxed font-body mb-8">
                {current.text}
              </p>
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div>
                  <p className="text-background-50 font-semibold text-base font-label">{current.name}</p>
                  <p className="text-foreground-400 text-sm font-label">{current.role}</p>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setActive((active - 1 + testimonials.length) % testimonials.length)}
                    className="w-10 h-10 rounded-full flex items-center justify-center border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-left-line"></i>
                  </button>
                  <button
                    onClick={() => setActive((active + 1) % testimonials.length)}
                    className="w-10 h-10 rounded-full flex items-center justify-center border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>

              <div className="flex items-center gap-2 mt-6">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActive(i)}
                    className={`h-1.5 rounded-full transition-all cursor-pointer ${
                      i === active ? 'w-8 bg-accent-500' : 'w-4 bg-foreground-600'
                    }`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}